<template>
  <div :class="['container-style', {'disabled': disabled}]">
    <div :class="['opt', {'isSelected': fontStyle.weight}]" @click="handleAddBold">
      <v-icon size="16" :color="fontStyle.weight ? 'bt_color' : ''">fa-solid fa-bold</v-icon>
    </div>
    <div :class="['vertical-divider', {'someOptIsSelected': fontStyle.weight || fontStyle['font-style']}]"></div>
    <div :class="['opt', {'isSelected': fontStyle['font-style']}]" @click="handleAddItalic">
      <v-icon size="16" :color="fontStyle['font-style'] ? 'bt_color' : ''">fa-solid fa-italic</v-icon>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FormBoldItalic',
  props: {
    value: {type: Object, required: true},
    disabled: {type: Boolean, default: false}
  },

  computed: {
    fontStyle: {
      get () { return this.value },
      set (v) { 
        this.$emit('input', v)
      }
    }
  },

  methods: {
    handleAddBold () {
      if (this.fontStyle.weight) this.fontStyle.weight = ''
      else this.fontStyle.weight = '900'
    },

    handleAddItalic () {
      if (this.fontStyle['font-style']) this.fontStyle['font-style'] = ''
      else this.fontStyle['font-style'] = 'italic'
    }
  }
}
</script>

<style scoped>
.container-style {
  position: relative;
  display: flex;
  height: 40px;
  border-radius: 8px;
  background-color: #F6F7F7;
  cursor: pointer;
}

.disabled {
  pointer-events: none;
  opacity: 0.7;
}

.opt {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;  
  border: 1px solid #EDEDF1;
}

.opt:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-right: 0;
}

.opt:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-left: 0;
}

.vertical-divider {
  height: 100%;
  width: 1px;
  background-color: #EDEDF1;
}

.vertical-divider.someOptIsSelected {
  background-color: #0067AF80;
}

.opt.isSelected {
  background-color: #E1F2FEB2;
  border-color: #0067AF80;
}
</style>
